import React from 'react';
import { Info } from 'lucide-react';

interface TourButtonProps {
  onClick: () => void;
  showBadge?: boolean;
}

const TourButton: React.FC<TourButtonProps> = ({ onClick, showBadge = false }) => {
  return (
    <div className="relative">
      <button
        onClick={onClick}
        className="inline-flex items-center justify-center p-2 bg-white text-brandColor rounded-lg border border-gray-200 hover:bg-brandColor/10 hover:border-brandColor/30 transition-all"
        title="Take a page tour"
      >
        <Info className="h-5 w-5" />
      </button>

      {showBadge && (
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brandColor/60 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-brandColor"></span>
        </span>
      )}
    </div>
  );
};

export default TourButton;
